import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    Input,
    TemplateRef,
} from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TemplateObservable } from '@bazis/shared/classes/template-observable';
import { BazisControlValueAccessor } from '@bazis/form/components/control-value-accessor.component';

@UntilDestroy()
@Component({
    selector: 'bazis-input-range',
    templateUrl: './input-range.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisInputRangeComponent extends BazisControlValueAccessor implements AfterViewInit {
    @Input() minNumber: number = null;

    @Input() maxNumber: number = null;

    @Input() increment: number = null;

    // показывать пин или нет
    @Input() pin: boolean = true;

    // Кастомный шаблон пина
    @Input() customPinTemplate: TemplateRef<any> = null;

    // Отображение шкалы
    @Input() showScale: boolean = false;

    @Input() disabled = false;

    @Input() dualThumbs = false;

    value: TemplateObservable<number | null> = new TemplateObservable<number | null>(null);

    values: TemplateObservable<{ from: number | null; to: number | null }> =
        new TemplateObservable<{ from: number | null; to: number | null }>({
            from: null,
            to: null,
        });

    ngAfterViewInit() {
        if (this.dualThumbs) {
            this.values.set(this.ngControl.control.value);
        } else {
            this.value.set(this.ngControl.control.value);
        }
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    public writeValue(value: any): void {
        if (!this.ngControl.control) return;

        if (this.dualThumbs) {
            const newValueFrom =
                value.from === '' || value.from === undefined || value.from === null
                    ? null
                    : +value.from;
            const newValueTo =
                value.to === '' || value.to === undefined || value.to === null ? null : +value.to;
            this.values.set({ from: newValueFrom, to: newValueTo });
        } else {
            const newValue = value === '' || value === undefined || value === null ? null : +value;
            this.value.set(newValue);
        }
    }

    updateValue(value) {
        if (this.dualThumbs) {
            if (this.values._?.from !== value.from || this.values._?.to !== value.to) {
                this.values.set(value);
                this.onChange(value);
            }
        } else if (this.value._ !== value) {
            this.value.set(value);
            this.onChange(value);
        }
    }
}
